import React, { useEffect, useRef, useState } from 'react';
import copyToClipboard from '../utils/copyToClipboard';

const COPY_FEEDBACK_MS = 3000;

const CopyableField = ({
  value,
  displayValue,
  decorIcon,
  actionButtons = [],
}) => {
  const [copied, setCopied] = useState(false);
  const copiedTimeoutRef = useRef(null);

  useEffect(() => {
    return () => {
      if (copiedTimeoutRef.current) {
        clearTimeout(copiedTimeoutRef.current);
      }
    };
  }, []);

  const handleCopy = (event) => {
    event.stopPropagation();
    copyToClipboard(value);

    setCopied(true);
    if (copiedTimeoutRef.current) {
      clearTimeout(copiedTimeoutRef.current);
    }
    copiedTimeoutRef.current = setTimeout(() => {
      setCopied(false);
    }, COPY_FEEDBACK_MS);
  };

  return (
    <div className="flex items-stretch border border-gray-300 rounded bg-white min-w-0 overflow-hidden min-h-8">
      {decorIcon && (
        <span
          className="flex items-center justify-center w-8 shrink-0 text-gray-400"
          aria-hidden="true"
        >
          <i className={decorIcon} />
        </span>
      )}
      <div className="flex items-center flex-1 min-w-0 overflow-hidden pl-2 pr-3">
        <span className="truncate text-sm text-gray-900 w-full">
          {displayValue ?? value}
        </span>
      </div>
      {actionButtons.map((button, index) => (
        <React.Fragment key={index}>
          <div className="w-px bg-gray-300 shrink-0 self-stretch" />
          <button
            type="button"
            className="flex items-center justify-center w-8 shrink-0 text-gray-500 hover:text-gray-700 hover:bg-gray-50"
            onClick={button.onClick}
            title={button.title}
            aria-label={button.title}
          >
            <i className={button.icon} />
          </button>
        </React.Fragment>
      ))}
      <div className="w-px bg-gray-300 shrink-0 self-stretch" />
      <button
        type="button"
        className="flex items-center justify-center w-8 shrink-0 text-gray-500 hover:text-gray-700 hover:bg-gray-50"
        onClick={handleCopy}
        title={copied ? 'Copied' : 'Copy'}
        aria-label={copied ? 'Copied' : 'Copy'}
      >
        <i
          className={
            copied
              ? 'fa-solid fa-check text-green-500'
              : 'fa-regular fa-copy'
          }
        />
      </button>
    </div>
  );
};

export default CopyableField;
